export default __webpack_public_path__ + "static/media/newLogo.586c84fe.png";